import { FC } from "react";

import LoadingGif from "@assets/images/loading.gif";

export const Loading:FC<{isLoading?: boolean}> = ({ isLoading = false })=> {

    if(!isLoading) return null;

    return (
        <div 
            className="fixed -top-8 left-0 w-full h-full flex items-center justify-center z-50"
            style={{ backgroundColor: "#00000030" }}
        >
            <img src={LoadingGif} alt="Loading..." className="w-32 h-32" />
        </div>
    )
}
